import React, { useEffect } from 'react';
import './Blog.css'; // Import the CSS file
import Header from '../../componets/header/header';
import Footer from '../../componets/footer/footer';
import blog7 from '../../../assets/blog7-7.png'; // Import the image
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

function Blog7() {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header />
            <div className="about-page">
                <div className="blog-container">
                    <div className="blog-images">
                        <img src={blog7} alt="Certified Finance Manager CFM Course" />
                    </div>

                    <h1>Certified Finance Manager (CFM – GAQM USA) Course in Kochi, Kerala</h1>
                    <p>The Most Job-Oriented Global Finance Certification for Plus Two (+2), Graduates & Working Professionals.</p>

                    <p>Are you looking for a high-paying finance career without spending years completing a long degree? Or are you searching for a globally recognized finance certification that guarantees practical skills, global recognition, and fast career growth?</p>

                    <p>The Certified Finance Manager (CFM) from GAQM, USA is one of the most powerful job-oriented finance certifications you can pursue right after Plus Two (+2) or graduation. It opens doors to high-paying roles in finance, accounting, business analytics, FP&A, taxation, investment advisory, and corporate consulting all within months.</p>

                    <p>If you’ve been searching for:</p>
                    <ul>
                        <li>Best finance course after plus two in Kerala</li>
                        <li>Job-oriented finance courses in Kochi</li>
                        <li>Short-term finance diploma courses Kerala</li>
                        <li>Best certification for finance jobs in India</li>
                    </ul>
                    <p>…then CFM (GAQM) is the perfect match for your career ambitions.</p>

                    <h3 style={{ fontSize: "23px" }}>Why Choose Certified Finance Manager (CFM - GAQM)?</h3>
                    <p>The CFM certification is designed for those who want a strong foundation in global finance, including:</p>
                    <ul>
                        <li>Financial Management | Corporate Finance | Capital Budgeting</li>
                        <li>Financial Analysis | Cost Control | Risk Management</li>
                        <li>Investment Decisions | Working Capital | Financial Planning</li>
                    </ul>
                    <p>Whether you're a fresher or a working professional, CFM gives you industry-ready skills that companies look for today.</p>

                    <h3 style={{ fontSize: "23px" }}>Top Job Roles After CFM (GAQM)</h3>
                    <p>Completing the Certified Finance Manager program opens the door to high-demand roles such as:</p>
                    <ul>
                        <li>Financial Analyst</li>
                        <li>Finance Executive</li>
                        <li>Cost Analyst</li>
                        <li>Investment Advisor</li>
                        <li>Business Analyst</li>
                        <li>Financial Planner</li>
                        <li>FP&A Associate</li>
                        <li>Risk & Compliance Analyst</li>
                    </ul>
                    <p>Finance companies, Big 4 consulting firms, corporates, and startups actively hire CFM-certified candidates due to their hands-on, practical understanding of financial decision-making.</p>

                    <h3 style={{ fontSize: "23px" }}>Course Duration & Structure</h3>
                    <p>The CFM program is a short-term, job-oriented finance course ranging between 2 to 3 months, depending on your training mode.</p><p> It is suitable for:</p>
                    <ul>
                        <li>Plus Two (+2) pass students</li>
                        <li>Graduates in any stream</li>
                        <li>Working professionals looking to upskill</li>
                        <li>Students aiming for finance jobs in India or abroad</li>
                    </ul>

                    <h3 style={{ fontSize: "23px" }}>Why Choose Meantoir Global Academy for CFM?</h3>
                    <p>At Meantoir Global Academy, you learn directly from industry experts and finance practitioners. </p><p>We proudly stand as Kerala’s #1 Finance Training Institute, offering globally recognized courses with 100% Placement Assistance.</p>

                    <h3 style={{ fontSize: "18px" }}>What Makes Us Special?</h3>
                    <ul>
                        <li>Practical, Job-Oriented Training</li>
                        <li>Real Industry Case Studies</li>
                        <li>GAQM Authorized Training Support</li>
                        <li>Interview Preparation + Resume Building</li>
                        <li>Dedicated Placement Assistance</li>
                    </ul>

                    <p>Our mission is simple: equip you with global finance skills and get you placed in a high-paying job. For complete details, please visit our Courses Page.</p>

                    <h3 style={{ fontSize: "23px" }}>Why CFM Is the Best Job-Oriented Finance Course in Kerala</h3>
                    <p>The Certified Finance Manager (CFM - GAQM) stands out because:</p>
                    <ul>
                        <li>It requires no degree to start</li>
                        <li>It provides global recognition</li>
                        <li>It prepares you for finance jobs within months</li>
                        <li>It equips you with core financial decision-making skills</li>
                        <li>It is one of the best short-term finance courses after plus two</li>
                    </ul>

                    <p>Whether you dream of joining the Big 4, entering corporate finance, or building a stable career abroad, this certification is a strong foundation.</p>

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
                        <Button type="primary" onClick={() => navigate('/blog6')}>Previous</Button>
                        <Button type="primary" onClick={() => navigate('/blog8')}>Next</Button>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Blog7;
